module.exports = __webpack_public_path__ + "media/background-music.94e6f59d.mp3";